import type { IconData } from '@stacksjs/iconify-core'

export const borderVertical: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M272 456V40h-32v432h32zm168-16h32v32h-32zm-133.818 0h33.455v32h-33.455zm-133.818 0h33.455v32h-33.455zm200.727 0h33.455v32h-33.455zm-267.636 0h33.455v32h-33.455zM40 440h32v32H40zm0-133.817h32v33.454H40zm0 66.909h32v33.454H40zm0-133.82h32v33.455H40zm0-66.908h32v33.454H40zm0-66.909h32v33.454H40zM40 40h32v32H40zm266.182 0h33.455v32h-33.455zm-133.818 0h33.455v32h-33.455zm200.727 0h33.455v32h-33.455zm-267.636 0h33.455v32h-33.455zM440 40h32v32h-32zm0 333.091h32v33.454h-32zm0-66.909h32v33.454h-32zm0-200.728h32v33.454h-32zm0 66.909h32v33.454h-32zm0 66.909h32v33.455h-32zm-133.818 0h33.455v33.455h-33.455zm66.909 0h33.455v33.455h-33.455zm-200.727 0h33.455v33.455h-33.455zm-66.909 0h33.455v33.455h-33.455z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default borderVertical
